<script setup lang="ts">
import BaseButton from './BaseButton.vue';

interface Props {
  size?: 'small' | 'large';
  htmlType?: 'button' | 'submit' | 'reset';
  loading?: boolean;
  disabled?: boolean;
  block?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'large',
  htmlType: 'button',
  loading: false,
  disabled: false,
  block: false,
});
</script>

<template>
  <BaseButton v-bind="props" type="primary" class="button-primary">
    <slot></slot>
    <template v-for="slotName in Object.keys($slots)" #[slotName]>
      <slot :name="slotName"></slot>
    </template>
  </BaseButton>
</template>

<style lang="less" scoped>
.button-primary {
  background-color: @color-primary;
  border-color: @color-primary;
  color: white;

  &:hover {
    background-color: fade(@color-primary, 90%);
    border-color: fade(@color-primary, 90%);
  }

  &:active {
    background-color: fade(@color-primary, 70%);
    border-color: fade(@color-primary, 70%);
  }

  &:focus {
    background-color: fade(@color-primary, 90%);
    border-width: 2px;
    border-color: @color-mid-green;
  }
}
</style>
